import machineTypeDocs from "../data/machine_type_docs.json";

const DOC_INDEX = new Map();

const buildDocIndex = () => {
	if (DOC_INDEX.size > 0) return;
	if (!Array.isArray(machineTypeDocs)) return;
	machineTypeDocs.forEach((doc) => {
		const locationId = doc?.LocationID;
		const serialNumber = doc?.SerialNumber;
		if (!locationId || !serialNumber) return;
		const key = `${locationId}::${serialNumber}`;
		if (!DOC_INDEX.has(key)) DOC_INDEX.set(key, doc);
	});
};

export const getMachineDocEntry = ({ locationId, serialNumber }) => {
	if (!locationId || !serialNumber) return null;
	buildDocIndex();
	const key = `${locationId}::${serialNumber}`;
	return DOC_INDEX.get(key) || null;
};

export const hasMachineExternalDoc = ({ locationId, serialNumber }) => {
	const entry = getMachineDocEntry({ locationId, serialNumber });
	return entry?.HasDoc === "Y";
};

export const buildExternalLoginUrl = ({ templateUrl, username, password }) => {
	if (!templateUrl || !username || !password) return "";
	return templateUrl
		.replace(/{{\s*amf_method_username\s*}}/g, encodeURIComponent(username))
		.replace(/{{\s*amf_method_pass\s*}}/g, encodeURIComponent(password));
};

export const buildExternalTargetUrl = ({ username, group, machine }) => {
	if (!username || !group || !machine) return "";
	// Match legacy AMF redirect behavior:
	// group: replace spaces and "&" with "-"
	// machine: replace spaces with "%20"
	const normalizedGroup = String(group).replace(/[ &]/g, "-");
	const normalizedMachine = String(machine).replace(/ /g, "%20");
	return `https://amfmethod.com/Locations/${encodeURIComponent(username)}/${encodeURIComponent(normalizedGroup)}/${normalizedMachine}`;
};

export const openExternalDocumentation = ({ loginUrl, targetUrl }) => {
	if (!loginUrl || !targetUrl) return false;
	const docsTab = window.open("about:blank", "_blank");
	const loginPopupFeatures = "popup=yes,width=480,height=640,left=80,top=80,resizable=yes,scrollbars=yes";
	const loginWindow = window.open(loginUrl, "_blank", loginPopupFeatures);

	const navigateDocs = () => {
		if (docsTab && !docsTab.closed) {
			docsTab.location.replace(targetUrl);
			docsTab.focus?.();
			return;
		}
		// Guaranteed fallback so the user lands on target URL even if popup/tab is blocked.
		window.location.assign(targetUrl);
	};

	setTimeout(() => {
		navigateDocs();
		try {
			loginWindow?.close?.();
		} catch {
			// Ignore cross-window close issues.
		}
	}, 2200);

	return true;
};
